import $http from '@/plugins/axios'

const RESOURCE_NAME = '/admin/giftcard'

export default {
  getAllPaged (params) {
    return $http().get(`${RESOURCE_NAME}/paged`, {
      params: params
    })
  },
  startGiftCardReportFile (params) {
    return $http().get(`${RESOURCE_NAME}/giftcard-file`, {
      params: params
    })
  },
  getDownloadStatus (taskId) {
    return $http().get(`${RESOURCE_NAME}/report-download-status/${taskId}`).then(res => res)
  },
  getAll (params) {
    return $http().get(RESOURCE_NAME, {
      params: params
    })
  },
  get (id) {
    return $http().get(`${RESOURCE_NAME}/${id}`)
  },
  async getGiftCardImage () {
    const res = await $http().get(`${RESOURCE_NAME}/Image`)
    return res
  },
  async setGiftCardImage (file) {
    const formData = new FormData()
    formData.append("file", file, file.name)
    return $http().post(`${RESOURCE_NAME}/UpdateImage`, formData)
  },
  getGiftCard (giftCardNumber) {
    return $http()({
      url: `${RESOURCE_NAME}/{${giftCardNumber.trim()}}`,
      method: "POST",
      handleError: false
    })
  },
  addPaymentMethod (giftCardId, userId) {
    return $http().post(`${RESOURCE_NAME}/SaveGiftCardPayment/${giftCardId}/${userId}`)
  },
  removePaymentMethod (giftCardId, userId) {
    return $http().delete(`${RESOURCE_NAME}/DeleteGiftCardPayment/${giftCardId}/${userId}`)
  },
  /* Not sure why this does not work but it crashes */
  updateGiftCard (userId, giftcard) {
    console.log(userId)
    console.log(giftcard)
    return $http.post(`${RESOURCE_NAME}/updateGiftCard/${userId}`, giftcard, { handleError: false })
  },
  decryptGiftCard (encryptedGiftCardNumber) {
    return $http().get(`${RESOURCE_NAME}/DecryptGiftCard`, { params: { encryptedGiftCardNumber: encryptedGiftCardNumber } })
  }
}
